import React from "react";
import styles from "./ProteinCalculator.module.scss";
import { SelectField } from "../SelectField";
import { FormActions } from "../FormActions";
import { Disclaimer } from "../../components/Disclaimer";
import { NumericField } from "../../../../secondary/NumericField/NumericField";
import { DISCLAIMER_TEXT } from "../constant";

export const PatientInfoForm = ({ formData, setFormData, errors, patientTypes, loading, onCalculate }) => {
  return (
    <div className={styles.section}>
      <h3 className={styles.sectionHeading}>Enter Patient Information</h3>

      <NumericField
        id="protein-weight"
        label="Weight"
        required
        suffix="kg"
        value={formData.weight}
        onChange={(v) => setFormData((prev) => ({ ...prev, weight: v }))}
        error={errors.weight}
      />

      <SelectField
        id="protein-patient-type"
        label="Type of Patient"
        required
        value={formData.patientType}
        onChange={(v) => setFormData((prev) => ({ ...prev, patientType: v }))}
        options={patientTypes}
        placeholder="Select patient type"
        error={errors.patientType}
      />

      <FormActions onClick={onCalculate} loading={loading} label="Calculate" />

      <Disclaimer>{DISCLAIMER_TEXT}</Disclaimer>
    </div>
  );
};
